export const listOrders = `
   query listOrders($filter: OrdersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listOrders(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              customerId
              subscriptionId
              createdByUsername
              createdByUser {
                name
                givenName
                familyName
                email
              }
              created
              updated
           }
           nextToken
       }
   }
`;

export const getOrder = `
   query getOrder($id:ID!) {
       getOrder(id:$id) {
         id
         customerId
         subscriptionId
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         created
         updated
       } 
}`;
